module.exports = __webpack_public_path__ + "static/media/KMH_5077.1a2cb18e.jpg";